module.exports = __webpack_public_path__ + "media/images/bg/mosaic/hidden-message-afbc9866a51108a85723c415522b4f49.svg";